import { call, put } from "redux-saga/effects";
import api from "../../util/api";
import { PRINT_TAGS_URL, OFFICE_REPLENISHMENT_PO_URL } from "../../util/constants/api.constants";
import { toQueryParam } from "../../util/utils";
import {
  fetchOfficeReplenishmentPOListFailed,
  fetchOfficeReplenishmentPOListSuccess,
} from "./actions";

export function* fetchOfficeReplenishmentPO(action: any): Generator {
  try {
    const url = OFFICE_REPLENISHMENT_PO_URL.OFFICE_REPLENISHMENT_PO_LIST;
    const data: any = yield call(api.post, url, action.payload);
    yield put(fetchOfficeReplenishmentPOListSuccess(data));

    // Call the success callback if provided
    if (action.onSuccess) {
      yield call(action.onSuccess);
    }
  } catch (e: any) {
    yield put(fetchOfficeReplenishmentPOListFailed({ message: e.message }));
  }
}

export function officeReplenishmentPOVendorList(payload: any) {
  let url = OFFICE_REPLENISHMENT_PO_URL.OFFICE_REPLENISHMENT_PO_LIST;
  return api.get(url, payload);
}

export function officeReplenishmentVendorList() {
  let url = OFFICE_REPLENISHMENT_PO_URL.OFFICE_REPLENISHMENT_VENDORS_LIST;
  return api.get(url);
}

export function getOffices(payload: any) {
  let url = `${PRINT_TAGS_URL.NONCLOSEDOFFICES}`;
  return api.get(url);
}

export function fetchofficeReplenishmentPOHistory(payload: any) {
  let url = OFFICE_REPLENISHMENT_PO_URL.OFFICE_REPLENISHMENT_PO_HISTORY;
  return api.get(url, payload);
}

export function SubmitReplenishmentPO(payload: any) {
  let url = OFFICE_REPLENISHMENT_PO_URL.SAVE_REPLENISHMENT_PO;
  return api.post(url, payload);
}